import { render, staticRenderFns } from "./PhoneField.vue?vue&type=template&id=89ed5902"
import script from "./PhoneField.vue?vue&type=script&lang=ts"
export * from "./PhoneField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports